(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("xes-frontend-ui/lib/utils/ajax"));
	else if(typeof define === 'function' && define.amd)
		define(["xes-frontend-ui/lib/utils/ajax"], factory);
	else if(typeof exports === 'object')
		exports["VueDropUpload"] = factory(require("xes-frontend-ui/lib/utils/ajax"));
	else
		root["VueDropUpload"] = factory(root["xes-frontend-ui/lib/utils/ajax"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_84__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition